import React, { ReactElement, useEffect, useState } from 'react';
import TimelinePostItem from './TimelinePost/TimelinePostItem';
import { Container, Row, Spinner } from 'react-bootstrap';
import './Timeline.scss';
import { useGetListPostMutation } from '../../../services/api/apiProvider';
import { ResponsePostTimeline } from '../../../services/api/models/response/responseTimeline';
import InfiniteScroll from 'react-infinite-scroll-component';
import { RequestPostTimeline } from '../../../services/api/models/request/requestTimeline';

type Props = {
  userId?: string;
};

const Timeline = ({ userId }: Props): ReactElement => {
  const [option, setOption] = useState<RequestPostTimeline>({
    numOfPage: 0,
    numInPage: 10,
    userId: userId || undefined,
  });
  const [listPost, setListPost] = useState<ResponsePostTimeline[]>([]);
  const [hasMore, setHasMore] = useState(false);

  const [getListPost, result] = useGetListPostMutation();

  useEffect(() => {
    fetchListPostData();
  }, []);

  const fetchListPostData = async () => {
    const data = await getListPost(option).unwrap();
    if (data) {
      setListPost(data);
      if (data.length >= option.numInPage) {
        setHasMore(true);
      }
    }
  };

  const fetchMoreData = async () => {
    const newOption: RequestPostTimeline = {
      numOfPage: option.numOfPage + 1,
      numInPage: option.numInPage,
      userId: userId || undefined,
    };
    const data = await getListPost(newOption).unwrap();
    if (data) {
      const newList = listPost.concat(data);
      setListPost(newList);
      setOption(newOption);
    }
  };

  const renderList = () => {
    if (listPost) {
      return (
        <InfiniteScroll
          dataLength={listPost.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            result.isLoading && (
              <div className="block-group__loading">
                <Spinner
                  animation="border"
                  style={{ color: 'var(--color-primary)' }}
                />
              </div>
            )
          }
        >
          {listPost.map((post) => (
            <TimelinePostItem key={post.id} post={post} />
          ))}
        </InfiniteScroll>
      );
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center timeline-root__wrapper">
        <div className="timeline-root">{renderList()}</div>
      </Row>
    </Container>
  );
};
export default Timeline;
